<div class="bg-alt">
  <header>
    <div class="container reg-bg">
    
      <div class="row">
        <app-logo></app-logo>
      </div>
    </div>
    <div class="reg-head">
      <div class="container">
        <div class="row">
          <h1 [innerHtml]="'CONFIRM.HEAD' | translate:data"></h1>
        </div>
      </div>
    </div>
  </header>

</div>
<main class="container confirm-bg">
  <div class="row">
    <div class="panel">
      <div class="panel__left">
        <p class="confirm-desc" [innerHtml]="'CONFIRM.DESC' | translate:data"></p>
      </div>
      <div class="panel__right">
        <img [src]="'CONFIRM.CARD_IMG' | translate:data">
      </div>
    </div>    
  </div>
</main>
<footer class="container confirm-bg-alt">
  <div class="row">
    <div class="terms-head" [innerHtml]="'TERMS.HEAD' | translate"></div>
    <div class="terms-desc confirm-para" [innerHtml]="'CONFIRM.TERMS' | translate:data"></div>
    <a [href]="'CONSENTS.PRIVACY_POLICY_LINK' | translate" tabindex="0" class="info-terms" [attr.aria-label]="'CONSENTS.PRIVACY_POLICY_ARIA' | translate" [innerHtml]="'CONSENTS.PRIVACY_POLICY' | translate" target="_blank"></a>
    <div role="button" class="cookie-consent" tabindex="0" [innerHtml]="'CONSENTS.COOKIE_PREFS' | translate"></div>
  </div>
</footer>
